import { Box, Button, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { bankDetailsList, QrPaymentSettlemntList, rechargeTypeList } from './QRBeneficiaryConst'
import * as sx from '../../../../../common/stylesInline/report_daily_branch'
import { Item } from '../../../../../common/snippets'
import DropDownOA from '../../../../../common/dropDownOA'
import Lineinput from '../../../../../common/lineinput'
import { requiredLabelTxt } from '../../../../BrnchUsrMaster/BranchMaster/BrnchMasterConstant'
import { QRUpdateTbl1Data } from '../constants'
import QRTable from './QRTable'
import { connect } from 'react-redux'
import { getMantisPaySettleDeatails, getMantisAccDetailInsertUpdate, getDQMantisTestFundTransfer } from '../../../../../../store/Acounting/acounting_action'
import { focusElemnt, isEmpty, navigation1, navigation3 } from '../../../../../common/helper'
import { updateAlertError } from '../../../../../../store/common/common_action'
import { getBranchDetails } from '../../../../../../store/branchAndUserMaster/BUMAction'
import SuccessAndErrorModal from '../../../../../common/SuccessAndErrorModal'

const QRBeneficiaryUpdate = (props) => {
    const {
        data: { common, branchAndUserMasterReducer }, getMantisPaySettleDeatails, getMantisAccDetailInsertUpdate, getBranchDetails, getDQMantisTestFundTransfer, updateAlertError
    } = props
    const { BranchDetailsList } = branchAndUserMasterReducer
    const { loginData } = common
    const [rechargeType, setRechargeType] = useState(4)
    const [QRPayment, setQRPayment] = useState('')
    const [branchRechargeData, setBranchRechargeData] = useState([])
    const [partyRechargeData, setPartyRechargeData] = useState([])
    const [mavenData, setMavenData] = useState([])
    const [bkngDelQRData, setBkngDelQRData] = useState([])
    const [posData, setPosData] = useState([])
    const [QRbranch, setQRbranch] = useState('')
    const [isSuccess, setIsSuccess] = useState(false)
    const [msg, setMsg] = useState('')
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
    const [QRBeneficiaryValue, setQRBeneficiaryValue] = useState({
        IsActive: 0,
        AccountName: '',
        AccountNumber: '',
        IFSCCode: '',
        BankName: '',
        MobileNo: '',
        EmailID: '',
        SettlementDays: '',
        TransactionFeePer: '',
        BranchID: 0,
        InsertUpdate: 'Insert',
        BeneficiaryAccountDetailsID: 0,
        PaymentProductTypeId: 4
    })
   useEffect(()=>{
    focusElemnt('branchRecharge')
   },[])
    useEffect(() => {
        if (!isEmpty(loginData)) {
            getTablesData()
        }
    }, [loginData])
    const getTablesData = () => {
        let body = {
            CompanyID: loginData?.intCompanyID,
            BusinessVerticalID: 3
        }
        getMantisPaySettleDeatails(body).then((res) => {
            if (res?.status) {
                if (res?.Data?.Table?.length > 0) {
                    let newData = res?.Data?.Table
                    let posValues = newData?.filter((item) => item?.PaymentProductTypeId === 2)
                    let branRechgValues = newData?.filter((item) => item?.PaymentProductTypeId === 4)
                    let BkngQRValues = newData?.filter((item) => item?.PaymentProductTypeId === 1)
                    let MavenValues = newData?.filter((item) => item?.PaymentProductTypeId === 3)
                    let partyRechrgValues = newData?.filter((item) => item?.PaymentProductTypeId === 6)

                    setPosData(posValues)
                    setBranchRechargeData(branRechgValues)
                    setBkngDelQRData(BkngQRValues)
                    setMavenData(MavenValues)
                    setPartyRechargeData(partyRechrgValues)
                } else {
                    setPosData([])
                    setBranchRechargeData([])
                    setBkngDelQRData([])
                    setMavenData([])
                    setPartyRechargeData([])
                }
            } else {
                updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
                setPosData([])
                setBranchRechargeData([])
                setBkngDelQRData([])
                setMavenData([])
                setPartyRechargeData([])
            }
        })
    }
    useEffect(() => {
        if (!isEmpty(loginData)) {
            const body = {
                intUserID: 0,
                intCompanyID: loginData.intCompanyID,
                intBranchID: 0,
                strBranchName: "",
                strBranchCode: "",
                intStateID: 0,
                intCityID: 0,
                intIsActive: 1
            }
            getBranchDetails(body)
        }
    }, [loginData])
    const leftData = [
        { name: "Account Name", type: "string", field: "AccountName", maxLength: 150, id:'accName', nextId:'accNo', prevId:'' },
        { name: "IFSC Code", type: "string", field: "IFSCCode", maxLength: 11, id:'ifscCode', nextId:'bankName', prevId:'accNo' },
        { name: "Registered Mob No", type: "number", field: "MobileNo", maxLength: 10 , id:'mobileNo', nextId:'emailId', prevId:'bankName'},
        { name: "Settlement Days", type: "number", field: "SettlementDays", maxLength: 3 , id:'settlementDays', nextId:'transactionFeePer', prevId:'emailId'},

    ]
    const rightData = [
        { name: "Account Number", type: "number", field: "AccountNumber", maxLength: 18, id:'accNo', nextId:'ifscCode', prevId:'accName' },
        { name: "Bank Name", type: "string", field: "BankName", maxLength: 150, id:'bankName', nextId:'mobileNo', prevId:'ifscCode' },
        { name: "Registered Email ID", type: "string", field: "EmailID", maxLength: 100, id:'emailId', nextId:'settlementDays', prevId:'mobileNo' },
        { name: "Transaction Fee %", type: "number", field: "TransactionFeePer", maxLength: 4 , id:'transactionFeePer', nextId:'saveBtn', prevId:'settlementDays'},
    ]
    const handleSave = () => {
        let isEdit = QRBeneficiaryValue?.InsertUpdate === 'Update' ? true : false
        if (QRBeneficiaryValue?.AccountName === '') {
            updateAlertError({ show: true, msg: 'Please enter the Account Name', nextId: 'accName' })
        } else if (QRBeneficiaryValue?.AccountNumber === '') {
            updateAlertError({ show: true, msg: 'Please enter the Account Number', nextId: 'accNo' })
        } else if (QRBeneficiaryValue?.IFSCCode === '') {
            updateAlertError({ show: true, msg: 'Please enter the IFSC Code', nextId: 'ifscCode' })
        } else if (QRBeneficiaryValue?.BankName === '') {
            updateAlertError({ show: true, msg: 'Please enter the Bank Name', nextId: 'bankName' })
        } else if (QRBeneficiaryValue?.MobileNo === '') {
            updateAlertError({ show: true, msg: 'Please enter the Registered Mobile Number', nextId: 'mobileNo' })
        } else if (QRBeneficiaryValue?.EmailID === '') {
            updateAlertError({ show: true, msg: 'Please enter the Registered Email ID', nextId: 'emailId' })
        } else if (QRBeneficiaryValue?.SettlementDays === '') {
            updateAlertError({ show: true, msg: 'Please enter the Settlement Days', nextId: 'settlementDays' })
        } else if (QRBeneficiaryValue?.TransactionFeePer === '') {
            updateAlertError({ show: true, msg: 'Please enter the Transaction Fee Percentage', nextId: 'transactionFeePer' })
        }
        else {
            let body = {
                UserID: loginData?.intUserID,
                BusinessVerticalID: 3,
                CompanyID: loginData?.intCompanyID,
                AccountName: QRBeneficiaryValue?.AccountName,
                AccountNumber: QRBeneficiaryValue?.AccountNumber,
                IFSCCode: QRBeneficiaryValue?.IFSCCode,
                BankName: QRBeneficiaryValue?.BankName,
                MobileNo: QRBeneficiaryValue?.MobileNo,
                EmailID: QRBeneficiaryValue?.EmailID,
                SettlementDays: Number(QRBeneficiaryValue?.SettlementDays),
                TransactionFeePer: Number(QRBeneficiaryValue?.TransactionFeePer),
                IsActive: QRBeneficiaryValue?.IsActive,
                BranchID: QRBeneficiaryValue?.BranchID,
                InsertUpdate: QRBeneficiaryValue?.InsertUpdate,
                BeneficiaryAccountDetailsID: QRBeneficiaryValue?.BeneficiaryAccountDetailsID,
                PaymentProductTypeID: QRBeneficiaryValue?.PaymentProductTypeId
            }
            getMantisAccDetailInsertUpdate(body).then((res) => {
                if (res?.status === 'Success') {
                    if (isEdit) {
                        setMsg(`QR Beneficiary Updated Successfully`)
                    } else {
                        setMsg(`QR Beneficiary Inserted Successfully`)
                    }
                    setIsSuccess(true);

                } else {
                    //show error
                }
            })
        }
    }
    const handleTestTransfer = (val) => {
        let body = {
            intUserID: loginData?.intUserID,
            intCompanyID: loginData?.intCompanyID,
            BeneficiaryAccountDetailsID: val
        }
        getDQMantisTestFundTransfer(body).then((res) => {
            if (res.status === 'Success') {

            } else {

            }
        })
    }
    const QRInfo = {
        QRBeneficiaryValue, BranchDetailsList, loginData, setQRBeneficiaryValue, setQRbranch, setQRPayment, setMsg, setIsSuccess,
    }
    const validateEmail = (e) => {
        let value = e.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (value === '') {
          return
        } else if (!emailRegex.test(value)) {
          setQRBeneficiaryValue((prev)=>({...prev,EmailID:''}))
          updateAlertError({ show: true, msg: 'Invalid Email Id', nextId: '' })
        }
      }
      const validateTransFeePercentage = (e, key) => {
        let value = e.target.value;
        if (value >= 100 || value === '') {
            setQRBeneficiaryValue((prev)=>({...prev,TransactionFeePer:''}))
          updateAlertError({ show: true, msg: 'Invalid Transfer Fee Percentage', nextId:''})
        }
      }
      const handleMobileNoValidation = (value) => {
		let regex = /^\d{10}$/;
		if (value && !regex.test(value)) {
            setQRBeneficiaryValue((prev)=>({...prev,MobileNo:''}))
          updateAlertError({ show: true, msg: 'Invalid Mobile Number', nextId: '' })
		}
	}
    return (
        <>
            <Box >
                <Box sx={{ ...sx.reportFlex, paddingBottom: '10px' }}>
                    {rechargeTypeList.map((obj) => (
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id={obj?.idVal}
                                    checked={QRBeneficiaryValue?.PaymentProductTypeId === obj.id}
                                    onChange={() => {
                                        setQRBeneficiaryValue((prev) => ({
                                            ...prev,
                                            PaymentProductTypeId: obj.id,
                                            IsActive: 0,
                                            AccountName: '',
                                            AccountNumber: '',
                                            IFSCCode: '',
                                            BankName: '',
                                            MobileNo: '',
                                            EmailID: '',
                                            SettlementDays: '',
                                            TransactionFeePer: '',
                                            BranchID: 0,
                                            InsertUpdate: 'Insert',
                                            BeneficiaryAccountDetailsID: 0,
                                        }))
                                        setQRPayment('')
                                        setQRbranch('')
                                    }}
                                    disabled={false}
                                    onKeyDown={(e) => {
                                        navigation1(e,obj?.nextId,obj?.prevId)
                                     }}
                                />
                            }
                            label={obj.name}
                        />
                    ))}
                </Box>
                <Divider />
                <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', paddingBottom: '12px' }}>
                    <Item sx={sx.itemsx}>
                        <DropDownOA
                            label={'QR Payment Settlement For'}
                            id={'QRPaymentSettlementFor'}
                            data={QrPaymentSettlemntList || []}
                            defaultvalue={QRPayment?.name || QRPayment}
                            value={QRPayment?.name || QRPayment}
                            onSelect={(val) => {
                                setQRPayment(val)
                                if (val.id === 0) {
                                    setQRbranch('')
                                }
                            }}
                            noCross={true}
                            onReset={() => {
                                setQRPayment('')
                            }}
                            idKey={`id`}
                            dataKey={`name`}
                            minWidth="400px"
                            nextId={QRPayment?.id===1?'selBranch':'QRPaymentActive'}
                            prevId={'pos'}
                        />
                    </Item>
                    {QRPayment?.id === 1 && <Item sx={sx.itemsx}>
                        <DropDownOA
                            label={'Branch'}
                            id={'selBranch'}
                            data={BranchDetailsList || []}
                            defaultvalue={QRbranch?.BranchName}
                            value={QRbranch?.BranchName}
                            onSelect={(val) => {
                                setQRbranch(val)
                                setQRBeneficiaryValue((prev) => ({
                                    ...prev,
                                    BranchID: val.BranchID
                                }))
                            }}
                            noCross={true}
                            onReset={() => {
                            }}
                            idKey={`BranchID`}
                            dataKey={`BranchName`}
                            minWidth="400px"
                            nextId={'QRPaymentActive'}
                            prevId={'QRPaymentSettlementFor'}
                        />
                    </Item>}
                    <Item sx={sx.itemsx}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id={`QRPaymentActive`}
                                    checked={Number(QRBeneficiaryValue?.IsActive) === 1}
                                    onChange={(e) => {
                                        setQRBeneficiaryValue((prev) => ({
                                            ...prev,
                                            IsActive: e.target.checked ? 1 : 0
                                        }))
                                    }}
                                    disabled={false}
                                    onKeyDown={(e) => { 
                                        navigation1(e,'accName',QRPayment?.id===1?'selBranch':'QRPaymentSettlementFor',)
                                    }}
                                />
                            }
                            label={'is Active'}
                        />
                    </Item>
                </Box>
                <Divider />
                <Box sx={{ ...sx.reportFlex, display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', paddingX: '14px', justifyContent: 'space-between' }}>
                    <Box sx={{ ...sx.reportFlex, width: '50%', padding: '0px 0px', display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', paddingX: '14px', justifyContent: 'space-between', alignItems: 'center' }}>
                        {leftData?.map((obj) => (
                            <Box key={obj.field} sx={{ display: 'flex', width: '100%', flexDirection: 'row', flexWrap: 'nowrap', paddingX: '14px', justifyContent: 'space-between', alignItems: 'center' }}> {/* Use a key for each mapped item */}
                                <Typography sx={{ width: '30%', fontFamily: 'Roboto', fontSize: '14px' }}>
                                    {obj?.name || ""}
                                </Typography>
                                <Item className={'input--wrapper btmSpaceNotRequired'} style={{ width: '70%' }} >
                                    <Lineinput
                                        id={obj?.id}
                                        value={QRBeneficiaryValue?.[obj?.field]}
                                        maxLength={obj?.maxLength}
                                        onChange={(e) => {
                                            setQRBeneficiaryValue((prev) => ({
                                                ...prev,
                                                [obj?.field]:obj?.field==='MobileNo'?(e.target.value).replaceAll(/\D/g, ''): e.target.value 
                                            }));
                                        }}
                                        onBlur={(e) => { 
                                            if(obj?.field==='MobileNo'){
                                                handleMobileNoValidation(e.target.value)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            navigation1(e,obj?.nextId,obj?.prevId)
                                        }}
                                    />
                                </Item>
                            </Box>
                        ))}
                    </Box>
                    <Box sx={{ ...sx.reportFlex, width: '50%', padding: '0px 0px', display: 'flex', flexDirection: 'column', flexWrap: 'nowrap', paddingX: '14px', justifyContent: 'space-between', alignItems: 'center' }}>
                        {rightData?.map((obj) => (
                            <Box key={obj.field} sx={{ display: 'flex', width: '100%', flexDirection: 'row', flexWrap: 'nowrap', paddingX: '14px', justifyContent: 'space-between', alignItems: 'center' }}> {/* Use a key for each mapped item */}
                                <Typography sx={{ width: '30%', fontFamily: 'Roboto', fontSize: '14px' }}>
                                    {obj?.name || ""}
                                </Typography>
                                <Item className={'input--wrapper btmSpaceNotRequired'} style={{ width: '70%' }} >
                                    <Lineinput
                                        id={obj?.id}
                                        value={QRBeneficiaryValue?.[obj?.field]}
                                        maxLength={obj?.maxLength}
                                        onChange={(e) => {
                                            const inputValue = e.target.value;
                                            // Regex to validate the input
                                            const regex = /^(?!0\d)(\d+(\.\d{0,2})?|(\.\d{1,2}))?$/;
                                            setQRBeneficiaryValue((prev) => ({
                                                ...prev,
                                                [obj?.field]:obj?.field==='TransactionFeePer'?regex.test(inputValue)?inputValue:'': inputValue
                                            }));
                                        }}
                                        onBlur={(e) => { 
                                            if(obj?.field==='EmailID'){
                                                validateEmail(e) 
                                            }else if(obj?.field==='TransactionFeePer'){
                                                validateTransFeePercentage(e)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            navigation1(e,obj?.nextId,obj?.prevId)
                                        }}
                                    />
                                </Item>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <Box sx={sx.reportFlex}>
                    <Item sx={{ ...sx.itemsx, width: '100vw' }} className="disabled-wrapper">
                        <Button variant="contained" id='saveBtn' style={{ ...sx.fullHeight, ...sx.novp, minWidth: '100%' }} className="btn btn-primary"
                            onClick={(e) => {
                            e.preventDefault()
                                handleSave()
                            }}
                        onKeyDown={(e) => {
                            // e.preventDefault()
                            navigation3(e,'accName','transactionFeePer',()=>{})
                        }}
                        >
                            Save & Add Beneficiary
                        </Button>
                    </Item>
                </Box>
                {branchRechargeData && branchRechargeData?.length > 0 && <Box sx={sx.reportFlex} >
                    <QRTable tableData={branchRechargeData} tableHeader={'Branch Recharge'} QRInfo={QRInfo} />
                </Box>}
                {partyRechargeData && partyRechargeData?.length > 0 && <Box sx={sx.reportFlex}>
                    <QRTable tableData={partyRechargeData} tableHeader={'Party Recharge'} QRInfo={QRInfo} />
                </Box>}
                {mavenData && mavenData?.length > 0 && <Box sx={sx.reportFlex}>
                    <QRTable tableData={mavenData} tableHeader={'Maven'} QRInfo={QRInfo} />
                </Box>}
                {bkngDelQRData && bkngDelQRData?.length > 0 && <Box sx={sx.reportFlex}>
                    <QRTable tableData={bkngDelQRData} tableHeader={'Booking & Delivery QR '} QRInfo={QRInfo} />
                </Box>}
                {posData && posData?.length > 0 && <Box sx={sx.reportFlex}>
                    <QRTable tableData={posData} tableHeader={'POS'} QRInfo={QRInfo} />
                </Box>}
            </Box>
            <SuccessAndErrorModal
                handleClose={() => {
                    setIsSuccess(false); getTablesData()
                }} open={isSuccess} title={msg} modalStyle={modalStyle} />
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getMantisPaySettleDeatails, getMantisAccDetailInsertUpdate, getBranchDetails, getDQMantisTestFundTransfer, updateAlertError
}
export default connect(mapStateToProps, mapDispatchToProps)(QRBeneficiaryUpdate)
